/**
 * When an org's portal is moved to a new subdomain, the server keeps resolving
 * the old one (portal_configs.previous_subdomain) and reports the canonical
 * subdomain back to us. This works out where the visitor should actually be.
 *
 * The host suffix is taken from the current host rather than hardcoded, so a
 * staging portal redirects within staging and an unrecognised single-label host
 * (localhost) is left alone.
 */
const DNS_LABEL = /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/;

export function canonicalPortalRedirect(
  currentHost: string,
  canonicalSubdomain: string | undefined | null,
  pathname: string,
  search: string,
): string | null {
  if (!canonicalSubdomain) return null;
  // Never splice an unvalidated value into a host we are about to navigate to.
  if (!DNS_LABEL.test(canonicalSubdomain)) return null;

  const [label, ...rest] = currentHost.split(".");
  if (rest.length === 0) return null;
  if (label === canonicalSubdomain) return null;

  return `https://${canonicalSubdomain}.${rest.join(".")}${pathname}${search}`;
}
